export default __webpack_public_path__ + "static/media/sfane.96d3a826.jpg";